import React from "react";
import {TagsInput as MTagsInput} from "@mantine/core"

import {TagsInputProps} from "@mantine/core"

type TTagsInputProps = {
    /**
     * Tags for this component
     */
    tags?: Array<string>,
    setProps: (props : {tags: string[]}) => void
} & Omit<TagsInputProps, "onChange">

export const TagsInput = React.forwardRef<HTMLInputElement, TTagsInputProps>(({
                                                                                      id,
                                                                                      className,
                                                                                      tags,
                                                                                      setProps,
                                                                                      label = "Tags",
                                                                                      required = false,
                                                                                      styles,
                                                                                      ...others
                                                                                  }: TTagsInputProps, ref) => {
        const onTags = (tags: Array<string | number>) => {
            setProps({tags: tags.map((t) => t.toString())})
        }

        return (
            <MTagsInput
                ref={ref}
                className={className}
                label={label}
                value={tags?.map((tag) => tag.toString())}
                data={tags?.map((tag) => tag.toString())}
                onChange={onTags}
                splitChars={[",", " ", "|"]}
                clearable
                required={required}
                styles={{
                    pillsList: {
                        gap: "0.25rem",
                    },
                    inputField: {
                        minWidth: "3rem",
                    },
                    ...styles,
                }}
                {...others}
            />
        )
    }
)